import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import InterfaceProfilesHelpModal from "./Help";
import InterfaceProfileSettingsHelpModal from "./SettingsHelp";
import composedAPI from "./api";
import interfaceComposition from "./composition";

const ConfigInterfaceProfiles = ({ ...settings }) => (
    <>
      <ProfilesAndSettings
        {...interfaceComposition}
        {...composedAPI}
        {...settings}
      />
      <InterfaceProfilesHelpModal />
      <InterfaceProfileSettingsHelpModal />
    </>
  );

export default ConfigInterfaceProfiles;
